<app-session-expired *ngIf="sessionExpired"></app-session-expired>
<ng-container *ngIf="!sessionExpired">
	<div *ngIf="loggedIn; else loggingIn">
		<router-outlet *ngIf="isReportView"></router-outlet>
		<app-main *ngIf="!isReportView && !isIframe"></app-main>
	</div>
	<ng-template #loggingIn>
		<router-outlet *ngIf="showLogin"></router-outlet>	
	</ng-template>
</ng-container>
